const EmailResultModal = ({ result, onClose }) => (
  <div className="bg-white rounded-lg border border-ase-blue w-full md:w-[480px] pb-1">
    <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
      <p>Email Results</p>
      <p onClick={onClose} className="font-bold cursor-pointer text-2xl">X</p>
    </div>

    <div className="p-4 flex flex-col gap-4">
      {result.sent.length > 0 && (
        <p className="text-sm text-green-700 font-semibold">
          ✓ {result.sent.length} email{result.sent.length !== 1 ? 's' : ''} sent successfully
        </p>
      )}

      {result.failed.length > 0 && (
        <div className="flex flex-col gap-2">
          <p className="text-sm font-semibold text-red-600">
            {result.failed.length} recipient{result.failed.length !== 1 ? 's' : ''} could not be reached:
          </p>
          <div className="border border-red-200 rounded-md divide-y divide-red-100 max-h-64 overflow-y-auto">
            {result.failed.map(hire => (
              <div key={hire._id} className="px-3 py-2">
                <p className="text-sm font-medium">{hire.fullName}</p>
                <p className="text-xs text-gray-500">{hire.email}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      <button onClick={onClose} className="ase-button-primary text-sm">
        Close
      </button>
    </div>
  </div>
);

export default EmailResultModal;
